import { render, staticRenderFns } from "./reviewschedules.vue?vue&type=template&id=9623e7f8&scoped=true&"
import script from "./reviewschedules.vue?vue&type=script&lang=js&"
export * from "./reviewschedules.vue?vue&type=script&lang=js&"
import style0 from "./reviewschedules.vue?vue&type=style&index=0&id=9623e7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9623e7f8",
  null
  
)

export default component.exports